export const shouldPrintInline =
  !evite.detects.isMobile && // It's not a mobile device (i.e. it's desktop)
  !evite.detects.isIPad && // It's not an iPad
  !evite.detects.isIOS && // It's not an iOS device
  !evite.detects.isAndroid && // It's not an Android device
  typeof navigator.standalone === 'undefined'; // Double-confirming it's not an iOS device
